"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var preact_1 = require("preact");
function StationName(_ref) {
  var type = _ref.type,
    children = _ref.children;
  if (children) {
    switch (type) {
      case "F01":
      case "F21":
      case "F03":
      case "F04":
      case "F05":
      case "F02":
      case "F11":
      case "F12":
      case "F06":
      case "A01":
      case "A02":
      case "A03":
      case "A04":
      case "A05":
      case "A07":
      case "A08":
      case "A09":
      case "A10":
      case "A12":
      case "A13":
      case "A14":
      case "A15":
      case "A16":
      case "A17":
      case "C11":
      case "C21":
      case "C31":
      case "C14":
      case "C24":
      case "C34":
      case "C17":
      case "C27":
      case "C37":
      case "C19":
      case "C29":
      case "C39":
        return (0, preact_1.h)(preact_1.Fragment, null, (0, preact_1.h)("em", null, "\xB7"), children);
    }
    return null;
  }
  return null;
}
exports.default = StationName;